export default {"src":"/_next/static/media/checkbox.d6cb8f79.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};